<template>
  <div class="fg-home">
    <loading-state :state="state"></loading-state>
    <div v-if="state.isLoaded()">
      <div class="recent-games" v-if="home.smart.recent_game_keys.length">
        <h2 class="subtitle">Recent Games</h2>
        <section
          v-for="key in home.smart.recent_game_keys"
          :key="key"
        >
          <GamePreview class="standalone" :game="home.games[key]" :showingWithContest="false"></GamePreview>
        </section>
      </div>
      <div class="featured-contest" v-if="home.smart.recent_contest_keys.length">
        <h2 class="subtitle">Recent Contest</h2>
        <section
          v-for="key in home.smart.recent_contest_keys"
          :key="key"
        >
          <contest-games :contest="home.contests[key]"></contest-games>
        </section>
      </div>
      <div class="featured-contest" v-if="home.smart.featured_contest_keys.length">
        <h2 class="subtitle">Featured</h2>
        <section
          v-for="key in home.smart.featured_contest_keys"
          :key="key"
        >
          <contest-games :contest="home.contests[key]"></contest-games>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { UserHome } from '@/models/fantasygame/core'
import GamePreview  from '@/components/fantasygame/GamePreview'
import ContestGames  from '@/components/fantasygame/ContestGames'

export default {
  components: {
    GamePreview,
    ContestGames
  },
  data() {
    return {
      home: {},
      state: DataState.newLoading(),
    }
  },

  mounted() {
    UserHome.fetch().then((resp) => {
      this.home = resp
      this.state.changeToLoaded()
    }).catch((error) => {
      this.state.changeToError(error)
    })
  }
}
</script>